import { type DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import { adfDocumentToHtml } from '@canvas/adf/adf-to-html';
import { getAdfTextContentWithUrl } from '@canvas/adf/get-adf-text-content';
import { htmlToAdfDocument } from '@canvas/adf/html-to-adf';

import { getTextContent } from '../../lib/dom';
import { encodeHtml } from '../../utils';
import type { FieldType } from '../field-types';

const textFieldType: FieldType<DatabaseFieldType.TEXT> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY,
  ],

  isCsvImportSupported: true,

  renderExportView: ({ value }) => {
    const plainHtml = encodeHtml(value.plain).replace(/\r|\n|\r\n/g, '<br/>');
    if (value.rich?.content && value.rich.content.length > 0) {
      const html = adfDocumentToHtml(value.rich);
      return html || plainHtml;
    }
    return plainHtml;
  },

  parseFromHtml: (el) => {
    const plain = getTextContent(el);
    const html = el.html();
    if (html) {
      const rich = htmlToAdfDocument(html);
      if (rich) {
        return { plain: getAdfTextContentWithUrl(rich, ''), rich };
      }
    }
    return { plain };
  },

  getInitialValue: () => ({ plain: '' }),

  isEmptyValue: ({ value }) => !value.plain,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1.plain === value2.plain,

  getStringRepresentation: ({ value }) => value.plain,
};

export default textFieldType;
